"use client";
import * as React from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import RechargeOptions from "./RechargeOptions";
// import SearchRechargeBar from "./SearchRechargeBar";
// import RechargeTicketDetails from "./RechargeTicketDetails";
  
const RechargeAmountGrid = () => {
 
  return (
    <>
      <div className='page-body'>
        <Container fluid>
          <Row>
            <Col sm="12">
                {/* <SearchRechargeBar /> */}
                <RechargeOptions />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default RechargeAmountGrid;
